<template>
  <div class="double">
    <div class="flex">
      <div class="item">
        <img :src="pdd_min_bg" alt />
        <span>{{info.items[0].title}}</span>
      </div>
      <div class="item">
        <img :src="jd_min_bg" alt />
        <span>{{info.items[1].title}}</span>
      </div>
    </div>
    <mask-btn-group
      @moveUp="$emit('moveUp',idx)"
      @moveDown="$emit('moveDown',idx)"
      @edit="$emit('edit',idx)"
      @del="$emit('del',idx)"
      :info="info"
      :idx="idx"
      :moduleLength="moduleLength"
      :hasRecommend="hasRecommend"
    ></mask-btn-group>
  </div>
</template>

<script>
import maskBtnGroup from './maskBtnGroup';
import pdd_min_bg from '@imgs/pdd_min_bg.png';
import jd_min_bg from '@imgs/jd_min_bg.png';
export default {
  name: 'doubleModule',
  data: () => ({
    pdd_min_bg,
    jd_min_bg,
  }),
  components: {
    maskBtnGroup,
  },
  props: {
    idx: [String, Number],
    info: Object,
    moduleLength: [String, Number],
    mouduleName: {
      type: String,
      default: '',
    },
    hasRecommend: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.double {
  padding: 5px 10px;
  position: relative;
  .flex {
    display: flex;
    flex-direction: row;
    .item {
      flex: 1;
      text-align: center;
      position: relative;
      img {
        height: 56px;
      }
      span{
        color: #fff;
        display: inline-block;
        position: absolute;
        top: 21px;
        left: 25px;
        font-size: 14px;
      }
    }
  }
}
</style>